// src/api/menu.ts
import request from '../utils/request'

export function del(api: string, data:any) {
    return request({
        url: api,
        method: 'post',
        data: {'ids':data}
    })
}


export function getTableData(api:string, page: number, pageSize: number, search: Record<string, any> = {}) {
    return request({
        // url: '/api/v1/admin/complaint',
        url: api,
        method: 'get',
        params: {
            page,
            page_size: pageSize,
            search: JSON.stringify(search) // 直接传递搜索对象，无需 .value
        }
    });
}
export function toggleSwitch(api: string, id: string) {
    return request({
        url: api,
        method: 'post',
        data: {'id':id}
    })
}

// 获取路由列表
export function getUserRule(id:number=0) {
    return request({
        url: '/api/v1/admin/menu-rule/dropdown/'.concat(String(id)),
        method: 'get'
    })
}
export function getUserGroup(id:number=0) {
    return request({
        url: '/api/v1/admin/user/group/dropdown/'.concat(String(id)),
        method: 'get'
    })
}
export function getUserGroupDetail(id: number) {
    return request({
        url: '/api/v1/admin/user/group/detail/'.concat(String(id)),
        method: 'get'
    })
}
// 增加路由
export function addRule(data: Record<string, any> = {}) {
    return request({
        url: '/api/v1/admin/menu-rule/add',
        method: 'post',
        data:data
    })
}


export function editRule(data: Record<string, any> = {}) {
    return request({
        url: '/api/v1/admin/menu-rule/edit',
        method: 'post',
        data:data
    })
}
// 增加路由
export function addAdminGroup(data: Record<string, any> = {}) {
    return request({
        url: '/api/v1/admin/user/group/add',
        method: 'post',
        data:data
    })
}


export function editAdminGroup(data: Record<string, any> = {}) {
    return request({
        url: '/api/v1/admin/user/group/edit',
        method: 'post',
        data:data
    })
}

// 添加系统用户
export function addAdminUser(data: Record<string, any> = {}) {
    return request({
        url: '/api/v1/admin/user/add',
        method: 'post',
        data:data
    })
}


export function editAdminUser(data: Record<string, any> = {}) {
    return request({
        url: '/api/v1/admin/user/edit',
        method: 'post',
        data:data
    })
}

export function getAdminUserDetail(id: number) {
    return request({
        url: '/api/v1/admin/user/detail/'.concat(String(id)),
        method: 'get'
    })
}

// 获取用户信息

export function getLoginUserDetail() {
    return request({
        url: '/api/v1/admin/user/info',
        method: 'get'
    })
}

export function  addPaymentMethod(data: Record<string, any> = {}) {
    return request({
        url: '/api/v1/admin/payment-method/add',
        method: 'post',
        data:data
    })
}


export function getPaymentMethodChildren() {
    return request({
        url: '/api/v1/admin/payment-method/dropdown',
        method: 'get'
    })
}
/**
 * 保存数据的请求方法
 * @param api 请求地址（例如：'/system/cities'）
 * @param data 要提交的数据，默认为空对象
 * @returns Promise 请求结果
 */
export function saveData(api: string, data: Record<string, any> = {}) {
    return request({
        url: api,              // 接口地址
        method: 'post',        // 使用 POST 方法
        data: data             // 提交的数据体
    });
}

/**
 * 获取详情的请求方法
 * @param api 请求地址前缀（例如：'/system/cities'）
 * @param id 要获取详情的 ID
 * @returns Promise 请求结果
 */
export function getDetail(api: string, id: number) {
    return request({
        url: `${api}/${id}`,   // 拼接完整 URL，例如：/system/cities/5
        method: 'get'          // 使用 GET 方法
    });
}

export function getSelect(api: string) {
	return request({
	    url: `${api}`,   // 拼接完整 URL，例如：/system/cities/5
	    method: 'get'          // 使用 GET 方法
	});
}
export function exportTable(api: string, ids: any[] = [], extraParams: Record<string, any> = {}) {
    const params = new URLSearchParams();

    // 添加 ids 参数（如果有）
    if (ids.length > 0) {
        params.set('ids', ids.join(','));
    }

    // 添加额外参数
    Object.entries(extraParams).forEach(([key, value]) => {
        params.set(key, String(value));
    });

    return request({
        url: `${api}?${params.toString()}`,
        method: 'get',
        responseType: 'blob',
        timeout: 30000,
    }).then(res => res.data);
}


export function getCityList(api: string) {
    return request({
        url: `${api}`,   // 拼接完整 URL，例如：/system/cities/5
        method: 'get'          // 使用 GET 方法
    });
}

export function getDepartmentList(api: string, id: number) {
    return request({
        url: `${api}/${id}`,   // 拼接完整 URL，例如：/system/cities/5
        method: 'get'          // 使用 GET 方法
    });
}
export function select(api: string) {
    return request({
        url: `${api}`,   // 拼接完整 URL，例如：/system/cities/5
        method: 'get'          // 使用 GET 方法
    });
}
